// src/utils/getPractitionerDisplayName.js
import { getAuth } from 'firebase/auth';

/**
 * Single source of truth for practitioner's display name
 * Checks ALL possible storage locations and returns first valid name
 *
 * @param {Object} state - WebsiteBuilderContext state
 * @returns {string} The practitioner's display name or empty string
 */
export function getPractitionerDisplayName(state) {
  const auth = getAuth();

  // Try localStorage directly (in case context hasn't loaded it yet)
  let setupProfileName = null;
  let onboardingProfileName = null;
  let publicProfileName = null;

  try {
    const setupData = localStorage.getItem('practitioner_setup');
    if (setupData) {
      const parsed = JSON.parse(setupData);
      setupProfileName = parsed.profile?.displayName || parsed.profile?.display_name || parsed.profile?.name;
    }
  } catch (e) {
    console.error('Failed to parse practitioner_setup:', e);
  }

  try {
    const onboardingData = localStorage.getItem('practitioner_profile');
    if (onboardingData) {
      const parsed = JSON.parse(onboardingData);
      onboardingProfileName = parsed.displayName || parsed.display_name || parsed.name;
    }
  } catch (e) {
    console.error('Failed to parse practitioner_profile:', e);
  }

  try {
    const publicData = localStorage.getItem('publicProfile');
    if (publicData) {
      const parsed = JSON.parse(publicData);
      publicProfileName = parsed.displayName || parsed.display_name || parsed.name;
    }
  } catch (e) {
    console.error('Failed to parse publicProfile:', e);
  }

  // Check all possible sources in priority order
  // Priority: Settings > Context > Onboarding > Auth
  const sources = [
    setupProfileName,              // Public Profile settings (most recent)
    state?.profile?.displayName,   // Context state
    state?.profile?.fullName,
    onboardingProfileName,         // Onboarding data
    publicProfileName,             // Alternative public profile key
    state?.websiteData?.businessName,
    state?.websiteData?.name,
    auth?.currentUser?.displayName, // Firebase auth (least reliable)
  ];

  for (const source of sources) {
    if (
      source &&
      typeof source === 'string' &&
      source.trim() &&
      source.trim().toLowerCase() !== 'your name' &&
      source.trim().toLowerCase() !== 'your name here'
    ) {
      return source.trim();
    }
  }

  return ''; // Return empty string - let components handle the fallback display
}
